import { Component, OnInit } from '@angular/core';
import { EscolaService } from '../../services/escola.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-cursos-sugeridos',
  templateUrl: './cursos-sugeridos.component.html',
  styleUrls: ['../userpanel.component.css'],
  providers: [EscolaService]
})
export class CursosSugeridosComponent implements OnInit {

  public arrayTrilhaSuggestList = [];
  public arrayTrilhaComplementList = [];
  public loaderActivated = false;
  public baseUrl = environment.apiUrl;

  constructor(private _escolaService: EscolaService) {
    this.loaderActivated = true;
  }

  ngOnInit() {
    this.getTrail();
  }

  getTrail(): void {
    this._escolaService.getTrilha()
      .subscribe(result => {
        this.arrayTrilhaSuggestList = result.data;
        this.loaderActivated = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/cursos-sugeridos/cursos-sugeridos.component.ts